import _a0 from '../assets/KT_favicon.ico';
import _a1 from '../assets/Kuiken_Tech_White_Outline.png';
import _a2 from '../assets/ethical_image.png';
import _a3 from '../assets/innovative_image.png';
import _a4 from '../assets/tree_tech.png';
import _a5 from '../assets/Green_Logo.png';

const _map: Record<string, string> = {
  '/images/KT_favicon.ico': _a0,
  'KT_favicon.ico': _a0,
  '/images/Kuiken_Tech_White_Outline.png': _a1,
  'Kuiken_Tech_White_Outline.png': _a1,
  '/images/Green_Logo.png': _a5,
  'Green_Logo.png': _a5,
  '/images/ethical_image.png': _a2,
  'ethical_image.png': _a2,
  '/images/innovative_image.png': _a3,
  'innovative_image.png': _a3,
  '/images/tree_tech.png': _a4,
  'tree_tech.png': _a4,
};

/** Resolve an image path to a Vite-bundled URL with cache-busting hash.
 *  Falls back to the original path for remote URLs or unknown filenames. */
export function assetUrl(path: string): string {
  return _map[path] ?? path;
}
